module.exports = __webpack_public_path__ + "img/award.a35eafd8.svg";